import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/api";

export const StickyCta = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const vis = { hero: true, form: false };
    const update = () => setShow(!vis.hero && !vis.form);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        vis[e.target.id === "hero" ? "hero" : "form"] = e.isIntersecting;
      });
      update();
    });
    ["hero", "iscrizione"].forEach((id) => {
      const el = document.getElementById(id);
      if (el) io.observe(el);
    });
    return () => io.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-50 md:hidden"
        >
          <button type="button" onClick={() => scrollToId("iscrizione")} className="btn-gold w-full justify-between !px-6" data-testid="sticky-cta-btn">
            <span>Riserva il posto · €27 + IVA</span>
            <ArrowRight className="h-4 w-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
